// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/AuditMgtPage/AuditMgtPage.css */
.audit-mgt-page {
  animation: fadeIn 0.5s ease-in-out;
}

.page-header {
  display: flex;
  justify-content: flex-end; /* Align search bar to the right */
  margin-bottom: 24px;
}

.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 12px;
  width: 100%;
  max-width: 320px;
}
.page-search-bar img {
  height: 16px;
  opacity: 0.5;
}
.page-search-bar input {
  border: none;
  outline: none;
  padding: 10px 8px;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
}
.clear-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #9ca3af;
}

.table-container {
  background-color: #fff;
  border-radius: 12px;
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  white-space: nowrap;
}

.data-table th {
  background-color: #f2f7ff;
  color: #1e3a8a;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
}
.data-table td {
  color: #374151;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    justify-content: stretch;
  }
  .page-search-bar {
    max-width: none;
  }
  .data-table thead {
    display: none;
  }
  .data-table tr {
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
  }
  .data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }
  .data-table td:last-child {
    border-bottom: none;
  }
  .data-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #4b5563;
  }
}

@media (max-width: 480px) {
  .page-header h3 {
    font-size: 16px;
  }
  .data-table td {
    font-size: 12px;
  }
}

.audit-mgt-page .audit-search-filters {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(150px, 0.65fr) minmax(0, 1.5fr);
  gap: 16px;
  align-items: end;
  margin-bottom: 16px;
}
.audit-mgt-page .audit-search-filters > label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  color: #374151;
  font-size: 14px;
}
.audit-mgt-page .audit-search-filters input,
.audit-mgt-page .audit-search-filters select {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  font: inherit;
}
.audit-mgt-page .audit-search-filters .audit-search-box {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  min-width: 0;
  border-radius: 10px;
}
.audit-mgt-page .audit-search-filters .audit-search-box input {
  border: none;
}
.audit-mgt-page .audit-search-filters .clear-btn {
  flex-shrink: 0;
  min-width: 32px;
  min-height: 44px;
}
.audit-mgt-page .audit-filters {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: end;
  gap: 12px;
  margin-bottom: 24px;
}
.audit-mgt-page .audit-multi-filter {
  min-width: 0;
  align-self: start;
}
.audit-mgt-page .audit-multi-filter summary {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  cursor: pointer;
  list-style: none;
}
.audit-mgt-page .audit-multi-filter summary::-webkit-details-marker {
  display: none;
}
.audit-mgt-page .audit-multi-filter summary::after {
  content: "⌄";
}
.audit-mgt-page .audit-multi-filter[open] summary::after {
  transform: rotate(180deg);
}
.audit-mgt-page .audit-filter-value {
  margin-left: auto;
  color: #6b7280;
  font-size: 13px;
}
.audit-mgt-page .audit-filter-options {
  max-height: 240px;
  overflow-y: auto;
  overscroll-behavior: contain;
  margin-top: 8px;
  padding: 6px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}
.audit-mgt-page .audit-filter-options label {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 4px 8px;
  box-sizing: border-box;
  font-size: 13px;
  cursor: pointer;
  overflow-wrap: anywhere;
}
.audit-mgt-page .audit-filter-options label:hover {
  background: #f2f7ff;
  border-radius: 6px;
}
.audit-mgt-page .audit-filter-options input {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  accent-color: #174078;
}
.audit-mgt-page .audit-filters > button {
  min-height: 44px;
  padding: 10px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  color: #174078;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}
.audit-mgt-page .audit-filters > button:disabled {
  opacity: 0.5;
  cursor: default;
}
.audit-mgt-page .audit-multi-filter summary:focus-visible,
.audit-mgt-page .audit-filters button:focus-visible {
  outline: 2px solid #174078;
  outline-offset: 2px;
}
@media (max-width: 768px) {
  .audit-mgt-page .audit-search-filters {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 12px;
  }
  .audit-mgt-page .audit-search-filters .audit-search-box {
    grid-column: 1 / -1;
    grid-row: 1;
  }
  .audit-mgt-page .audit-search-filters input,
  .audit-mgt-page .audit-search-filters select {
    font-size: 16px;
  }
  .audit-mgt-page .audit-filters {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .audit-mgt-page .audit-filters > button {
    grid-column: 1 / -1;
    justify-self: end;
  }
  .audit-mgt-page .data-table td {
    overflow-wrap: anywhere;
    gap: 16px;
  }
  .audit-mgt-page .data-table td::before {
    flex-shrink: 0;
  }
}
@media (max-width: 400px) {
  .audit-mgt-page .audit-search-filters,
  .audit-mgt-page .audit-filters {
    grid-template-columns: minmax(0, 1fr);
  }
  .audit-mgt-page .audit-filters > button {
    width: 100%;
  }
}

/* Keep search styling independent of other pages' global search rules. */
.audit-mgt-page .audit-search-filters .audit-search-box {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  padding: 0 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}
.audit-mgt-page .audit-search-box:focus-within {
  border-color: #174078;
  box-shadow: 0 0 0 3px rgb(23 64 120 / 8%);
}
.audit-mgt-page .audit-search-box > img {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  object-fit: contain;
  opacity: 0.55;
}
.audit-mgt-page .audit-search-filters .audit-search-box > input {
  flex: 1 1;
  width: 0;
  min-width: 0;
  height: 100%;
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  outline: none;
  box-shadow: none;
  background: transparent;
  color: #374151;
}
.audit-mgt-page .audit-search-box > input::placeholder {
  color: #9ca3af;
}
.audit-mgt-page .audit-search-box > .clear-btn {
  flex: 0 0 28px;
  min-width: 28px;
  min-height: 36px;
  padding: 0;
  border: 0;
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditMgtPage/AuditMgtPage.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB,EAAE,kCAAkC;EAC7D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,4EAA4E;EAC5E,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE;IACE,oDAAoD;IACpD,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;;IAEE,eAAe;EACjB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;;IAEE,qCAAqC;EACvC;EACA;IACE,WAAW;EACb;AACF;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB;;oBAEkB;AACpB;AACA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,SAAW;EACX,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB","sourcesContent":["/* src/pages/AuditMgtPage/AuditMgtPage.css */\n.audit-mgt-page {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.page-header {\n  display: flex;\n  justify-content: flex-end; /* Align search bar to the right */\n  margin-bottom: 24px;\n}\n\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 100%;\n  max-width: 320px;\n}\n.page-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n}\n.page-search-bar input {\n  border: none;\n  outline: none;\n  padding: 10px 8px;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n}\n.clear-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: #9ca3af;\n}\n\n.table-container {\n  background-color: #fff;\n  border-radius: 12px;\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n.data-table th {\n  background-color: #f2f7ff;\n  color: #1e3a8a;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: none;\n}\n.data-table td {\n  color: #374151;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .page-header {\n    justify-content: stretch;\n  }\n  .page-search-bar {\n    max-width: none;\n  }\n  .data-table thead {\n    display: none;\n  }\n  .data-table tr {\n    display: block;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    padding: 1rem;\n  }\n  .data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n  .data-table td:last-child {\n    border-bottom: none;\n  }\n  .data-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #4b5563;\n  }\n}\n\n@media (max-width: 480px) {\n  .page-header h3 {\n    font-size: 16px;\n  }\n  .data-table td {\n    font-size: 12px;\n  }\n}\n\n.audit-mgt-page .audit-search-filters {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(150px, 0.65fr) minmax(0, 1.5fr);\n  gap: 16px;\n  align-items: end;\n  margin-bottom: 16px;\n}\n.audit-mgt-page .audit-search-filters > label {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  color: #374151;\n  font-size: 14px;\n}\n.audit-mgt-page .audit-search-filters input,\n.audit-mgt-page .audit-search-filters select {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  min-height: 44px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px 12px;\n  background: #fff;\n  font: inherit;\n}\n.audit-mgt-page .audit-search-filters .audit-search-box {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  border-radius: 10px;\n}\n.audit-mgt-page .audit-search-filters .audit-search-box input {\n  border: none;\n}\n.audit-mgt-page .audit-search-filters .clear-btn {\n  flex-shrink: 0;\n  min-width: 32px;\n  min-height: 44px;\n}\n.audit-mgt-page .audit-filters {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;\n  align-items: end;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n.audit-mgt-page .audit-multi-filter {\n  min-width: 0;\n  align-self: start;\n}\n.audit-mgt-page .audit-multi-filter summary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 44px;\n  box-sizing: border-box;\n  padding: 12px 14px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  cursor: pointer;\n  list-style: none;\n}\n.audit-mgt-page .audit-multi-filter summary::-webkit-details-marker {\n  display: none;\n}\n.audit-mgt-page .audit-multi-filter summary::after {\n  content: \"⌄\";\n}\n.audit-mgt-page .audit-multi-filter[open] summary::after {\n  transform: rotate(180deg);\n}\n.audit-mgt-page .audit-filter-value {\n  margin-left: auto;\n  color: #6b7280;\n  font-size: 13px;\n}\n.audit-mgt-page .audit-filter-options {\n  max-height: 240px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  margin-top: 8px;\n  padding: 6px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n}\n.audit-mgt-page .audit-filter-options label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 44px;\n  padding: 4px 8px;\n  box-sizing: border-box;\n  font-size: 13px;\n  cursor: pointer;\n  overflow-wrap: anywhere;\n}\n.audit-mgt-page .audit-filter-options label:hover {\n  background: #f2f7ff;\n  border-radius: 6px;\n}\n.audit-mgt-page .audit-filter-options input {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  accent-color: #174078;\n}\n.audit-mgt-page .audit-filters > button {\n  min-height: 44px;\n  padding: 10px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  color: #174078;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer;\n}\n.audit-mgt-page .audit-filters > button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.audit-mgt-page .audit-multi-filter summary:focus-visible,\n.audit-mgt-page .audit-filters button:focus-visible {\n  outline: 2px solid #174078;\n  outline-offset: 2px;\n}\n@media (max-width: 768px) {\n  .audit-mgt-page .audit-search-filters {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    gap: 12px;\n  }\n  .audit-mgt-page .audit-search-filters .audit-search-box {\n    grid-column: 1 / -1;\n    grid-row: 1;\n  }\n  .audit-mgt-page .audit-search-filters input,\n  .audit-mgt-page .audit-search-filters select {\n    font-size: 16px;\n  }\n  .audit-mgt-page .audit-filters {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n  .audit-mgt-page .audit-filters > button {\n    grid-column: 1 / -1;\n    justify-self: end;\n  }\n  .audit-mgt-page .data-table td {\n    overflow-wrap: anywhere;\n    gap: 16px;\n  }\n  .audit-mgt-page .data-table td::before {\n    flex-shrink: 0;\n  }\n}\n@media (max-width: 400px) {\n  .audit-mgt-page .audit-search-filters,\n  .audit-mgt-page .audit-filters {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .audit-mgt-page .audit-filters > button {\n    width: 100%;\n  }\n}\n\n/* Keep search styling independent of other pages' global search rules. */\n.audit-mgt-page .audit-search-filters .audit-search-box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 46px;\n  padding: 0 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  overflow: hidden;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n.audit-mgt-page .audit-search-box:focus-within {\n  border-color: #174078;\n  box-shadow: 0 0 0 3px rgb(23 64 120 / 8%);\n}\n.audit-mgt-page .audit-search-box > img {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  object-fit: contain;\n  opacity: 0.55;\n}\n.audit-mgt-page .audit-search-filters .audit-search-box > input {\n  flex: 1 1 0;\n  width: 0;\n  min-width: 0;\n  height: 100%;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  outline: none;\n  box-shadow: none;\n  background: transparent;\n  color: #374151;\n}\n.audit-mgt-page .audit-search-box > input::placeholder {\n  color: #9ca3af;\n}\n.audit-mgt-page .audit-search-box > .clear-btn {\n  flex: 0 0 28px;\n  min-width: 28px;\n  min-height: 36px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
